import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse } from "antd";
import "./SideBar.css";
import { faCircle } from '@fortawesome/free-regular-svg-icons';

import { faBarsStaggered, faHouse, faTrophy, faMoneyBill1Wave, faMoneyBill, faGifts, faBoxes, faCogs, faBullhorn, faUser, faUserCircle, faWallet, faFileInvoiceDollar, faChartBar, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { decryptData } from "../../controllers/Encryption";
import { APP_VERSION } from "../../appVersion";

const { Panel } = Collapse;

const SidebarItem = ({ to, icon, name, isOpen, className }) => (
  <NavLink
    to={to}
    className={`link ${className || ""}`}
    activeClassName="active"
    title={name}
  >
    <div className="icon">{icon}</div>
    <div className={`link_text ${isOpen ? "visible" : "hidden"}`}>
      {name}
    </div>
  </NavLink>
);

const getInitials = (first = '', last = '') =>
  `${first.charAt(0)}${last.charAt(0)}`.toUpperCase() || 'A';

const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();
  const handleCollapseToggle = () => setIsOpen(o => !o);
  const user = JSON.parse(localStorage.getItem("ADMIN-INFO") || sessionStorage.getItem("AGENT-ADMIN-INFO"));
  const [PERMISSIONDATA, setPermissionData] = useState('');

  const handlePermission = async () =>{
    if(user && user.admin_type !== 'Super Admin'){
      const raw = localStorage.getItem("ADMIN-PERMISSION") || sessionStorage.getItem("ADMIN-PERMISSION");
      if(!raw || raw === 'null') return;
      const encrypted  = JSON.parse(raw);
      const decrypted  = await decryptData(encrypted);
      const permission = JSON.parse(decrypted);
      setPermissionData(permission);
    }
  }

  useEffect(()=>{
    const raw = localStorage.getItem("ADMIN-PERMISSION") || sessionStorage.getItem("ADMIN-PERMISSION");
    if(raw && raw !== 'null'){
      handlePermission();
    }
  },[])
  return (
    <div
      className={`container-fluid side_bar_main_div ${
        isOpen ? "sidebar-open" : "sidebar-closed"
      }`}
    >
      <div
        style={{ width: isOpen ? "268px" : "76px" }}
        className={`sidebar ${isOpen ? "is-open" : "is-collapsed"}`}
      >
        <div className="top_section">
          <div className="sidebar_logo_wrap" title="Crown King">
            <img src="/logo.png" className="sidebar_logo" alt="Crown King" />
          </div>
          <button
            type="button"
            className="bars"
            onClick={handleCollapseToggle}
            aria-label={isOpen ? "Collapse sidebar" : "Expand sidebar"}
          >
            <FontAwesomeIcon icon={faBarsStaggered} />
          </button>
        </div>
        <div className="my_sidebar_all_section">
          <SidebarItem
            to="/dashboard"
            icon={<FontAwesomeIcon icon={faHouse} />}
            name="Dashboard"
            isOpen={isOpen}
          />
          {(user?.admin_type === 'Super Admin') && (
            <React.Fragment>
              <Collapse accordion className="my_collapse_icon">
                <Panel
                  header={
                    <React.Fragment>
                         <FontAwesomeIcon icon={faUser} className="sidebar_collapse_iohomeoutline" />
                    
                      <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Accounts </span>
                    </React.Fragment>
                  }
                  key="categories"
                  className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                >
                  {user?.admin_type === 'Super Admin' &&(
                    <SidebarItem to="/sub-admin/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Sub Admin" isOpen={isOpen} />
                  )}
                </Panel>
              </Collapse>
            </React.Fragment>
          )}
          
          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.usersPermission?.list === 'Y'
          ) && (
            <React.Fragment>
              <Collapse accordion className="my_collapse_icon">
                <Panel
                  header={
                    <React.Fragment>
                      <FontAwesomeIcon icon={faUserCircle} className="sidebar_collapse_iohomeoutline" />
                      <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Users </span>
                    </React.Fragment>
                  }
                  key="categories"
                  className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                >
                  <SidebarItem to="/users/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                  {/* <SidebarItem to="/users/B2B-user-list"   icon={<FontAwesomeIcon icon={faCircle} />} name="B2B" isOpen={isOpen} /> */}
                  {/* <SidebarItem to="/users/B2C-user-list"   icon={<FontAwesomeIcon icon={faCircle} />} name="B2C" isOpen={isOpen} /> */}
                </Panel>
              </Collapse>
            </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.userRequest?.list === 'Y' ||
            PERMISSIONDATA?.userPullOutRequest?.list === 'Y'
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon icon={faUser} className="sidebar_collapse_iohomeoutline" />
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Request </span>
                  </React.Fragment>
                }
                key="userRequest"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.userRequest?.list === 'Y'
                ) && (
                  <SidebarItem to="/users/request-list" icon={<FontAwesomeIcon icon={faCircle} />} name="Request List" isOpen={isOpen} />
                )}
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.userPullOutRequest?.list === 'Y'
                ) && (
                  <SidebarItem to="/request/pull-out-list" icon={<FontAwesomeIcon icon={faCircle} />} name="Pull-Out List" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.rechargePoints?.list === 'Y'
          ) && (
            <React.Fragment>
              <Collapse accordion className="my_collapse_icon">
                <Panel
                  key="categories"
                  className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                  header={
                    <React.Fragment>
                      <FontAwesomeIcon icon={faMoneyBill} className="sidebar_collapse_iohomeoutline" />
                      <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Recharge </span>
                    </React.Fragment>
                  }
                >
                  <SidebarItem to="/recharge/b-point-list"   icon={<FontAwesomeIcon icon={faCircle} />} name="QR-Point" isOpen={isOpen} />
                </Panel>
              </Collapse>
            </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.promoCodes?.list === 'Y' ||
            PERMISSIONDATA?.promoCodesOrder?.list === 'Y' ||
            PERMISSIONDATA?.promoCodesVoucher?.list === 'Y' 
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon icon={faGifts} className="sidebar_collapse_iohomeoutline" />
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Promo Codes </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.promoCodes?.list === 'Y'
                ) &&(
                  <SidebarItem to="/promocodes/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.promoCodesOrder?.list === 'Y'
                ) &&(
                  <SidebarItem to="/promocodes/order"   icon={<FontAwesomeIcon icon={faCircle} />} name="Order" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.promoCodesVoucher?.list === 'Y'
                ) &&(
                  <SidebarItem to="/promocodes/vouchers/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Vouchers" isOpen={isOpen} />
                )}

              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.products?.list === 'Y' ||
            PERMISSIONDATA?.productVariant?.list === 'Y' ||
            PERMISSIONDATA?.productInventory?.list === 'Y' ||
            PERMISSIONDATA?.productOrder?.list === 'Y' 
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                        <FontAwesomeIcon icon={faBoxes} className="sidebar_collapse_iohomeoutline" />
                  
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Products </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.products?.list === 'Y'
                ) &&(
                  <SidebarItem to="/product/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.productVariant?.list === 'Y'
                ) &&(
                  <SidebarItem to="/product/variants/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Variants" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.productInventory?.list === 'Y'
                ) &&(
                  <SidebarItem to="/product/inventory/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Inventory" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.productOrder?.list === 'Y'
                ) &&(
                  <SidebarItem to="/product/order/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Orders" isOpen={isOpen} />
                )}
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.productInventory?.list === 'Y'
                ) &&(
                  <SidebarItem to="/product/inventory/logs"   icon={<FontAwesomeIcon icon={faCircle} />} name="Inventory Log" isOpen={isOpen} />
                )}
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.productVariant?.list === 'Y'
                ) &&(
                  <SidebarItem to="/product/variants/logs"   icon={<FontAwesomeIcon icon={faCircle} />} name="Variants Log" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.generalDataCMS?.edit === 'Y' ||
            PERMISSIONDATA?.bannerCMS?.list === 'Y' ||
            PERMISSIONDATA?.raffleCouponContentCMS?.edit === 'Y'
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon icon={faCogs} className="sidebar_collapse_iohomeoutline" />
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> CMS </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.generalDataCMS?.edit === 'Y'
                ) &&(
                  <SidebarItem to="/cms/general_data/addeditdata"   icon={<FontAwesomeIcon icon={faCircle} />} name="General Data" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.raffleCouponContentCMS?.edit === 'Y'
                ) &&(
                  <SidebarItem to="/cms/raffle-coupon-content/addeditdata"   icon={<FontAwesomeIcon icon={faCircle} />} name="Raffle Coupon Content" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.bannerCMS?.list === 'Y' 
                ) &&(
                  <SidebarItem to="/cms/banner/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Banner" isOpen={isOpen} />
                )}
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.pickupPoint?.list === 'Y' 
                ) &&(
                  <SidebarItem to="/cms/pickup-point/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Pickup Points" isOpen={isOpen} />
                )}

                  <SidebarItem to="/cms/winning-results/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Winning Results" isOpen={isOpen} />

              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.campaign?.list === 'Y' ||
            PERMISSIONDATA?.campaignOrder?.list === 'Y' ||
            PERMISSIONDATA?.campaignFreezes?.edit === 'Y' 
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon icon={faBullhorn} className="sidebar_collapse_iohomeoutline" />
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Campaign </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.campaign?.list === 'Y'
                ) &&(
                  <SidebarItem to="/campaign/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.campaignOrder?.list === 'Y'
                ) &&(
                  <SidebarItem to="/campaign/order/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Order" isOpen={isOpen} />
                )}
                 {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.campaignFreezes?.edit === 'Y'
                ) &&(
                  <SidebarItem to="/campaign/freezes"   icon={<FontAwesomeIcon icon={faCircle} />} name="Freezes" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

{(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.smartRtp?.list === 'Y' ||
            PERMISSIONDATA?.smartRtp?.reports === 'Y' ||
            PERMISSIONDATA?.smartRtp?.runtime === 'Y'
          ) && (
            <React.Fragment>
              <Collapse accordion className="my_collapse_icon">
                <Panel
                  header={
                    <React.Fragment>
                      <FontAwesomeIcon icon={faChartBar} className="sidebar_collapse_iohomeoutline" />
                      <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Smart RTP </span>
                    </React.Fragment>
                  }
                  key="smart-rtp"
                  className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                >
                  {(
                    user?.admin_type === 'Super Admin' ||
                    PERMISSIONDATA?.smartRtp?.list === 'Y'
                  ) && (
                    <>
                      <SidebarItem to="/smart-rtp/dashboard" icon={<FontAwesomeIcon icon={faCircle} />} name="Dashboard" isOpen={isOpen} />
                      <SidebarItem to="/smart-rtp/games" icon={<FontAwesomeIcon icon={faCircle} />} name="Games" isOpen={isOpen} />
                      <SidebarItem to="/smart-rtp/orders" icon={<FontAwesomeIcon icon={faCircle} />} name="Orders" isOpen={isOpen} />
                      <SidebarItem to="/smart-rtp/winners" icon={<FontAwesomeIcon icon={faCircle} />} name="Winners" isOpen={isOpen} />
                      <SidebarItem to="/smart-rtp/big-prize-monitor" icon={<FontAwesomeIcon icon={faCircle} />} name="Attack Mode" isOpen={isOpen} />
                      <SidebarItem to="/smart-rtp/big-prize/history" icon={<FontAwesomeIcon icon={faCircle} />} name="Attack Mode History" isOpen={isOpen} />
                      <SidebarItem to="/smart-rtp/big-prize/addeditdata" icon={<FontAwesomeIcon icon={faCircle} />} name="Bulk Attack Mode" isOpen={isOpen} />
                      <SidebarItem to="/smart-rtp/predict-distribution" icon={<FontAwesomeIcon icon={faCircle} />} name="Predict" isOpen={isOpen} />
                    </>
                  )}
                  {(
                    user?.admin_type === 'Super Admin' ||
                    PERMISSIONDATA?.smartRtp?.reports === 'Y' ||
                    PERMISSIONDATA?.smartRtp?.list === 'Y'
                  ) && (
                    <>
                      <SidebarItem to="/smart-rtp/reports" icon={<FontAwesomeIcon icon={faCircle} />} name="Reports" isOpen={isOpen} />
                      <SidebarItem to="/smart-rtp/analytics" icon={<FontAwesomeIcon icon={faCircle} />} name="Analytics" isOpen={isOpen} />
                    </>
                  )}
                  {(
                    user?.admin_type === 'Super Admin' ||
                    PERMISSIONDATA?.smartRtp?.runtime === 'Y' ||
                    PERMISSIONDATA?.smartRtp?.list === 'Y'
                  ) && (
                    <>
                      <SidebarItem to="/smart-rtp/audit-logs" icon={<FontAwesomeIcon icon={faCircle} />} name="Audit Logs" isOpen={isOpen} />
                      <SidebarItem to="/smart-rtp/runtime" icon={<FontAwesomeIcon icon={faCircle} />} name="Runtime" isOpen={isOpen} />
                    </>
                  )}
                </Panel>
              </Collapse>
            </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.raffleWinner?.list === 'Y'
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon icon={faTrophy} className="sidebar_collapse_iohomeoutline" />
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Raffle Winners </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.raffleWinner?.list === 'Y'
                ) &&(
                  <SidebarItem to="/raffle-winners/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.raffleDraw?.list === 'Y'
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                        <FontAwesomeIcon icon={faTrophy} className="sidebar_collapse_iohomeoutline" />
                  
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Raffle Draw </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.raffleDraw?.list === 'Y'
                ) &&(
                  <SidebarItem to="/raffle-draw/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.lottoWinner?.list === 'Y' ||
            PERMISSIONDATA?.lottoRedeem?.list === 'Y' ||
            PERMISSIONDATA?.lottoWinner?.analyser === 'Y'
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                        <FontAwesomeIcon icon={faMoneyBill1Wave} className="sidebar_collapse_iohomeoutline" />
                  
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Lotto Winners </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.lottoWinner?.list === 'Y'
                ) &&(
                  <SidebarItem to="/lotto-winners/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.lottoRedeem?.list === 'Y'
                ) &&(
                  <SidebarItem to="/lotto-winners/redeem-list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Redeem List" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.analyser?.list === 'Y'
                ) &&(
                  <SidebarItem to="/lotto-winners/analyser"   icon={<FontAwesomeIcon icon={faCircle} />} name="Analyser" isOpen={isOpen} />
                )}

              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.walletStatement?.list === 'Y'
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                        <FontAwesomeIcon icon={faWallet} className="sidebar_collapse_iohomeoutline" />
                  
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Wallets Statement </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.walletStatement?.list === 'Y'
                ) &&(
                  <SidebarItem to="/wallets-statement/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.transactions?.list === 'Y'
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon icon={faMoneyBill} className="sidebar_collapse_iohomeoutline" />
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Transactions </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.transactions?.list === 'Y'
                ) && (
                  <SidebarItem to="/transactions/list" icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.individualInvoice?.list === 'Y' ||
            PERMISSIONDATA?.bulkInvoice?.list === 'Y' 
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon icon={faFileInvoiceDollar} className="sidebar_collapse_iohomeoutline" />
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Invoice </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.individualInvoice?.list === 'Y'
                ) &&(
                  <SidebarItem to="/invoice/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Individual" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.bulkInvoice?.list === 'Y'
                ) &&(
                  <SidebarItem to="/invoice/bulk-list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Bulk" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

        {/* Winning Vouchers */}
          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.winningVouchers?.list === 'Y'
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon icon={faFileInvoiceDollar} className="sidebar_collapse_iohomeoutline" />
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Winning Vouchers </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.winningVouchers?.list === 'Y'
                ) &&(
                  <SidebarItem to="/winning-vouchers/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.winningVouchers?.generate === 'Y'
                ) &&(
                  <SidebarItem to="/winners/generate-voucher"   icon={<FontAwesomeIcon icon={faCircle} />} name="Generate Voucher" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.statisticsReport?.lotto === 'Y' ||
            PERMISSIONDATA?.statisticsReport?.voucher === 'Y' ||
            PERMISSIONDATA?.statisticsReport?.products === 'Y' ||
            PERMISSIONDATA?.statisticsReport?.lotto_redeem === 'Y' 
          ) && (
            <React.Fragment>
              <Collapse accordion className="my_collapse_icon">
                <Panel
                  header={
                    <React.Fragment>
                      <FontAwesomeIcon icon={faChartBar} className="sidebar_collapse_iohomeoutline" />
                      <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Statistics </span>
                    </React.Fragment>
                  }
                  key="categories"
                  className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                >
                  <SidebarItem to="/statistics-reports"   icon={<FontAwesomeIcon icon={faCircle} />} name="Reports" isOpen={isOpen} />
                </Panel>
              </Collapse>
            </React.Fragment> 
          )}
        </div>{/* end my_sidebar_all_section */}

        {/* Profile footer — pinned outside scroll area */}
        <div
          className="sb-profile"
          onClick={() => navigate("/sub-admin/addeditdata", { state: user })}
        >
          <div className="sb-avatar">
            {getInitials(user?.admin_first_name, user?.admin_last_name)}
          </div>
          {isOpen && (
            <>
              <div className="sb-profile-info">
                <div className="sb-profile-name">
                  {user?.admin_first_name} {user?.admin_last_name}
                </div>
                <div className="sb-profile-meta">
                  <span className="sb-profile-role">{user?.admin_type || "Admin"}</span>
                  <span className="sb-profile-version">v{APP_VERSION}</span>
                </div>
              </div>
              <FontAwesomeIcon icon={faChevronRight} className="sb-profile-arrow" />
            </>
          )}
        </div>
      </div>
      <main>{children}</main>
    </div>
  );
};

export default Sidebar;
